<template>
    <div class="mc-search-bar-by-time flex-row-start-center">
        <div class="mc-search-bar-picker">
            <el-date-picker style="width:200px" v-model="option.start" type="datetime" placeholder="开始时间" class="item"></el-date-picker>
            <el-date-picker style="width:200px" v-model="option.end" type="datetime" placeholder="结束时间" class="item"></el-date-picker>
        </div>
        <el-button :disabled="!(option.start && option.end)" class="mc-search-bar-btn" type="primary" icon="el-icon-search"
            size="mini" @click="searchSubmit"></el-button>
        <el-button v-if="option.start || option.end" class="mc-search-bar-btn" type="danger" icon="el-icon-close"
            size="mini" @click="resetSearch"></el-button>
    </div>
</template>

<script>
    export default {
        name: 'mc-search-bar-by-time',
        model: {
            props: 'timeOption',
            event: 'input'
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        start: null,
                        end: null
                    }
                }
            },
            searchSubmit: {
                type: Function,
                default: () => {},
            },
        },
        data() {
            return {}
        },
        computed: {
            option: {
                get: function () {
                    return this.value
                },
                set: function (val) {
                    this.$emit('input', val)
                }
            },
        },
        methods: {
            resetSearch() {
                this.option.start = null;
                this.option.end = null;
                this.searchSubmit();
            },
        },
        destroyed() {
            this.option.start = null;
            this.option.end = null;
        },
    }
</script>

<style lang="less">
    .mc-search-bar-by-time {
        width: 100%;
        height: 100%;

        .el-date-editor {
            margin-right: 10px;
        }

        .mc-search-bar-picker {
            // margin-right: 10px;
        }

        .mc-search-bar-btn {
            height: 40px;
        }
    }
</style>